module.exports = __webpack_public_path__ + "static/bad-marketing-logo-a9f502a132d0775034fe2fe36c05b7e7.svg";